/** @format */
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import * as formik from "formik";
import * as yup from "yup";
import { useState } from "react";
import { useCreateJob } from "../../../../../api/mutations/job.mutation";
import TextareaAutosize from "react-textarea-autosize";

function JobPostingForm({ onFormSubmit, showToast }) {
  const { Formik } = formik;
  const [selectedJobTypes, setSelectedJobTypes] = useState([]);
  const [hasDeadline, setHasDeadline] = useState(true);

  const handleDeadlineChange = (e) => {
    setHasDeadline(e.target.id === "yes-deadline");
  };

  const handleJobTypeToggle = (jobType) => {
    setSelectedJobTypes((prevSelected) =>
      prevSelected.includes(jobType)
        ? prevSelected.filter((type) => type !== jobType)
        : [...prevSelected, jobType]
    );
  };
  const jobTypes = [
    "Full-time",
    "Part-time",
    "Permanent",
    "Contract",
    "Temporary",
    "Freelance",
    "Internship",
    "Fresh Graduate",
    "Student Job",
  ];

  const schema = yup.object().shape({
    job_title: yup.string().required("Please enter your title"),
    description: yup.string().required("Please enter description"),
    experienceLevel: yup.string().required("Please enter the type of job"),
    salary: yup.string().required("Please enter the type of job"),
    posted_at: yup.string().required("Please enter the type of job"),
    location: yup.string().required("Please enter the type of job"),
    is_remote: yup.string().required("Please enter the type of job"),
    is_hybrid: yup.string().required("Please enter the type of job"),
    expiry: yup.date().nullable().required("Please enter the expiry date"),
  });

  const postJobMutation = useCreateJob({
    onSuccess: (data) => {
      showToast("Job created successfully!");
      onFormSubmit();
    },
    onError: (error) => {
      console.error("Error:", error.message);
      showToast("Error creating job.");
    },
    successMessage: "Created Successfully",
  });

  const onCreate = (data) => {
    console.log("Submitting form data:", data);
    postJobMutation.mutate({
      title: data.job_title,
      tag: "selectedJobTypes",
      description: data.description,
      level: data.experienceLevel,
      salary: data.salary,
      posted_at: data.expiry,
      location: data.location,
      is_remote: data.is_remote,
      is_hybrid: data.is_hybrid,
      expiry: data.expiry,
    });
  };

  const initialValues = {
    title: "",
    tag: "test",
    description: "",
    level: "",
    salary: "",
    posted_at: "",
    location: "",
    is_remote: true,
    is_hybrid: true,
    expiry: "",
  };

  return (
    <Formik
      //validationSchema={schema}
      onSubmit={onCreate}
      initialValues={initialValues}
      enableReinitialize
    >
      {({ handleSubmit, handleChange, values, touched, errors }) => (
        <Form noValidate onSubmit={handleSubmit}>
          <Row className="mb-2">
            <Form.Group
              as={Col}
              controlId="validationFormikJobTitle"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">Job Title</Form.Label>
              <Form.Control
                type="text"
                placeholder="Job Title"
                name="job_title"
                value={values.job_title}
                onChange={handleChange}
                isInvalid={!!errors.job_title}
                className="form-control mb-0"
              />
              <Form.Control.Feedback type="invalid">
                {errors.job_title}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group
              as={Col}
              controlId="validationFormikNumofPos"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">
                Number of Position
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Number"
                name="num_position"
                value={values.num_position}
                onChange={handleChange}
                isInvalid={!!errors.num_position}
                className="form-control mb-0"
              />
              <Form.Control.Feedback type="invalid">
                {errors.num_position}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group as={Col} className="form-group text-start">
              <Form.Label className="form-label fw-bold">Job Type</Form.Label>
              <div className="d-flex flex-wrap">
                {jobTypes.map((jobType, index) => (
                  <Button
                    key={index}
                    variant={
                      selectedJobTypes.includes(jobType) ? "success" : "light"
                    }
                    className="m-1 rounded-pill"
                    onClick={() => handleJobTypeToggle(jobType)}
                  >
                    {selectedJobTypes.includes(jobType) ? "-" : "+"} {jobType}
                  </Button>
                ))}
              </div>
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group
              as={Col}
              controlId="validationFormikBudgetSalary"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">
                Budget/Salary
              </Form.Label>
              <div className="mb-3">
                <Form.Check
                  inline
                  label="Fixed Salary"
                  name="salaryType"
                  type="radio"
                  id="fixed-salary"
                />
                <Form.Check
                  inline
                  label="Salary Range"
                  name="salaryType"
                  type="radio"
                  id="salary-range"
                />
                <Form.Check
                  inline
                  label="Negotiable"
                  name="salaryType"
                  type="radio"
                  id="negotiable"
                />
              </div>
              <Form.Control
                type="text"
                placeholder="Expected Salary"
                name="salary"
                value={values.salary}
                onChange={handleChange}
                isInvalid={!!errors.salary}
                className="form-control mb-0"
              />
              <Form.Control.Feedback type="invalid">
                {errors.salary}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group
              as={Col}
              controlId="validationFormikExperienceLevel"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">
                Experience Level
              </Form.Label>
              <Form.Select
                name="experienceLevel"
                value={values.experienceLevel}
                onChange={handleChange}
                isInvalid={!!errors.experienceLevel}
              >
                <option>Please select an option</option>
                <option value="junior">Junior</option>
                <option value="mid">Mid-level</option>
                <option value="senior">Senior</option>
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors.experienceLevel}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group
              as={Col}
              controlId="validationFormikJobDescription"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">
                Job Description
              </Form.Label>
              <TextareaAutosize
                minRows={5}
                placeholder="Describe the job responsibilities and requirements"
                name="description"
                value={values.description}
                onChange={handleChange}
                maxLength={5000} // Optional max length
                style={{ width: "100%" }}
              />
              <Form.Control.Feedback type="invalid">
                {errors.description}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group
              as={Col}
              controlId="validationFormikLocation"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">Location</Form.Label>
              <Form.Control
                type="text"
                placeholder="Kuala Lumpur"
                name="location"
                value={values.location}
                onChange={handleChange}
                isInvalid={!!errors.location}
                className="form-control mb-0"
              />
              <Form.Control.Feedback type="invalid">
                {errors.location}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group
              as={Col}
              controlId="validationFormikApplicationExpiry"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">
                Is there an application deadline?
              </Form.Label>
              <div className="mb-3">
                <Form.Check
                  inline
                  label="No"
                  name="applicationExpiry"
                  type="radio"
                  id="no-expiry"
                  onChange={handleDeadlineChange}
                  checked={!hasDeadline}
                />
                <Form.Check
                  inline
                  label="Yes"
                  name="applicationExpiry"
                  type="radio"
                  id="yes-expiry"
                  onChange={handleDeadlineChange}
                  checked={hasDeadline}
                />
              </div>
              {hasDeadline && (
                <Form.Group as={Col} controlId="formGridDeadlineDate">
                  <Form.Label className="form-label">
                    Select Deadline
                  </Form.Label>
                  <Form.Control
                    type="date"
                    name="expiry"
                    value={values.expiry}
                    placeholder="Select deadline"
                    required={hasDeadline}
                    onChange={handleChange}
                  />
                </Form.Group>
              )}
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Col className="text-end">
              <Button type="submit" variant="success">
                Post
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  );
}

export default JobPostingForm;
